unit UHistoryModel;

interface

uses
  UEssentialHelper, UStampModel, UPictureModel, Js;

type
  THistoryModel = class
  private
    FPicture: TPictureModel;
    FKind: TModelKind;
    FCreatedAt: TDateTime;
    FTransmitted: Boolean;
    FTransmittedAt: TDateTime;
    FStamp: TStampModel;
    FOnPropertyChanged: TPropertyChangedEvent;
    procedure ClearValues;
    procedure DoPropertyChanged(PropertyName: string);
    procedure HandleValueChanged(Sender: TObject; PropertyName: string);
    procedure SetValues(Json: string); overload;
    procedure SetValues(Obj: TJsObject); overload;
    procedure SetCreatedAt(const Value: TDateTime);
    procedure SetKind(const Value: TModelKind);
    procedure SetPicture(const Value: TPictureModel);
    procedure SetStamp(const Value: TStampModel);
    procedure SetTransmittedAt(const Value: TDateTime);
    procedure SetOnPropertyChanged(const Value: TPropertyChangedEvent);
  public
    constructor Create; overload;
    constructor Create(Json: string); overload;
    constructor Create(Picture: TPictureModel;
      TransmittedAt: TDateTime = 0); overload;
    constructor Create(Stamp: TStampModel;
      TransmittedAt: TDateTime = 0); overload;
    function ToJson: string;
    property Transmitted: Boolean read FTransmitted;
    property TransmittedAt: TDateTime read FTransmittedAt
      write SetTransmittedAt;
    property CreatedAt: TDateTime read FCreatedAt write SetCreatedAt;
    property Kind: TModelKind read FKind write SetKind;
    property Stamp: TStampModel read FStamp write SetStamp;
    property Picture: TPictureModel read FPicture write SetPicture;
    property OnPropertyChanged: TPropertyChangedEvent read FOnPropertyChanged
      write SetOnPropertyChanged;
  end;

implementation

uses
  WebLib.Json, System.SysUtils;

{ THistoryModel }

procedure THistoryModel.ClearValues;
begin
  Self.TransmittedAt := 0;
  Self.CreatedAt := 0;
  Self.Kind := mkUnknown;
  Self.Stamp := nil;
  Self.Picture := nil;
  Self.OnPropertyChanged := nil;
end;

constructor THistoryModel.Create;
begin
  Self.ClearValues;
end;

constructor THistoryModel.Create(Json: string);
begin
  Self.SetValues(Json);
end;

procedure THistoryModel.SetCreatedAt(const Value: TDateTime);
begin
  FCreatedAt := Value;
end;

procedure THistoryModel.SetKind(const Value: TModelKind);
begin
  FKind := Value;
end;

procedure THistoryModel.SetOnPropertyChanged(const Value
  : TPropertyChangedEvent);
begin
  FOnPropertyChanged := Value;
end;

procedure THistoryModel.SetPicture(const Value: TPictureModel);
begin
  FPicture := Value;
end;

procedure THistoryModel.SetStamp(const Value: TStampModel);
begin
  FStamp := Value;
end;

procedure THistoryModel.SetTransmittedAt(const Value: TDateTime);
begin
  FTransmittedAt := Value;
  FTransmitted := Value > 0;
  Self.DoPropertyChanged('TransmittedAt');
end;

procedure THistoryModel.SetValues(Obj: TJsObject);
begin
  Self.ClearValues;
  if Obj['TransmittedAt'] <> nil then
    Self.TransmittedAt := StrToDateTime(string(Obj['TransmittedAt']));
  if Obj['CreatedAt'] <> nil then
    Self.CreatedAt := StrToDateTime(string(Obj['CreatedAt']));
  if Obj['Kind'] <> nil then
    Self.Kind := StrToModelKind(string(Obj['Kind']));
  if Obj['Stamp'] <> nil then
    Self.Stamp := TStampModel.Create(string(Obj['Stamp']));
  if Obj['Picture'] <> nil then
    Self.Picture := TPictureModel.Create(string(Obj['Picture']));
end;

procedure THistoryModel.SetValues(Json: string);
var
  Obj: TJsObject;
begin
  Obj := TJsJson.parseObject(Json);
  Self.SetValues(Obj);
end;

function THistoryModel.ToJson: string;
var
  Obj: TJsonObject;
begin
  Obj := TJsonObject.Create;
  Obj.AddPair('TransmittedAt', DateTimeToStr(Self.TransmittedAt));
  Obj.AddPair('CreatedAt', DateTimeToStr(Self.CreatedAt));
  Obj.AddPair('Kind', ModelKindToStr(Self.Kind));
  if Self.Stamp <> nil then
    Obj.AddPair('Stamp', Self.Stamp.ToJson);
  if Self.Picture <> nil then
    Obj.AddPair('Picture', Self.Picture.ToJson);
  Result := Obj.ToJson;
  Obj.Free;
end;

constructor THistoryModel.Create(Stamp: TStampModel; TransmittedAt: TDateTime);
begin
  Self.ClearValues;
  Self.TransmittedAt := TransmittedAt;
  Self.CreatedAt := stamp.Zeitpunkt;
  Self.Kind := mkStamp;
  Self.Stamp := Stamp;
  Self.Stamp.OnValueChanged:=Self.HandleValueChanged;
end;

procedure THistoryModel.DoPropertyChanged(PropertyName: string);
begin
  if Assigned(Self.OnPropertyChanged) then
    Self.OnPropertyChanged(Self, PropertyName);
end;

procedure THistoryModel.HandleValueChanged(Sender: TObject;
  PropertyName: string);
begin
  Self.DoPropertyChanged(PropertyName);
end;

constructor THistoryModel.Create(Picture: TPictureModel;
  TransmittedAt: TDateTime);
begin
  Self.ClearValues;
  Self.TransmittedAt := TransmittedAt;
  Self.CreatedAt := Picture.Created;
  Self.Kind := mkPicture;
  Self.Picture := Picture;
end;

end.
